import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface EyebrowProps extends HTMLAttributes<HTMLElement> {
  as?: "p" | "span" | "div" | "h2" | "h3" | "h4" | "label";
  children: ReactNode;
}

/**
 * Editorial eyebrow label — the uppercase, tracked micro-caption that
 * sits above section headings on home-v4 and home-v5. Token-driven so
 * it adopts the active theme's accent colour automatically.
 */
export function Eyebrow({ as: Tag = "p", className, children, ...rest }: EyebrowProps) {
  const Component = Tag as "p";
  return (
    <Component
      className={cn(
        "text-eyebrow tracking-eyebrow uppercase font-semibold text-editorial-accent",
        className,
      )}
      {...rest}
    >
      {children}
    </Component>
  );
}
